import { __assign } from "tslib";
import { selectors } from '../../Stream';
import { getDataEntities } from '../../redux/entities/selectors';
import { reduxKey, streamId } from './constants';
function getStoreSlice(state) {
    return (state[reduxKey] || {
        isNewCollectionSaving: false,
        deviations: {},
    });
}
function getUserCollectionEntities(state) {
    var collections = getDataEntities(state).collections;
    if (!collections) {
        return {};
    }
    return collections;
}
function getCollectionsRaw(state) {
    var collectionIds = selectors.getItems(state, streamId) || [];
    if (!collectionIds.length) {
        return [];
    }
    return getCollectionsByFolderId(state, collectionIds);
}
function getCollectionsByFolderId(state, folderIds) {
    var collections = getUserCollectionEntities(state);
    return folderIds
        .filter(function (id) { return collections.hasOwnProperty(id); })
        .map(function (collectionId) { return collections[collectionId]; });
}
function getChangeType(added, removed, kept) {
    if (!added) {
        if (!removed) {
            return 'none';
        }
        if (!kept) {
            return 'removeAll';
        }
        if (removed === 1) {
            return 'removeOne';
        }
        return 'removeSome';
    }
    if (removed) {
        return 'misc';
    }
    if (added > 1) {
        return 'addMany';
    }
    return 'addOne';
}
function getDeviationState(state, deviationId) {
    var slice = getStoreSlice(state);
    return slice === null || slice === void 0 ? void 0 : slice.deviations[deviationId];
}
export function getCollection(state, folderId) {
    return getUserCollectionEntities(state)[folderId];
}
export function getUserCollections(state, deviationId) {
    var _a;
    var slice = getDeviationState(state, deviationId);
    var collections = slice
        ? getCollectionsRaw(state).map(function (collection) { return (__assign(__assign({}, collection), { isSelected: slice.selectedCollections.includes(collection.folderId) })); })
        : [];
    var streamInfo = {
        streamId: streamId,
        isInitialized: (_a = slice === null || slice === void 0 ? void 0 : slice.isInitializedForCollecting) !== null && _a !== void 0 ? _a : false,
        hasMore: selectors.hasMore(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        errorMsg: selectors.getErrorMsg(state, streamId),
        collections: collections,
    };
    return streamInfo;
}
export function getUserCollectionsHasMore(state, deviationId) {
    var _a;
    return !!((_a = getUserCollections(state, deviationId)) === null || _a === void 0 ? void 0 : _a.hasMore);
}
export function getUserCollectionsCount(state, deviationId) {
    var _a, _b, _c;
    return (_c = (_b = (_a = getUserCollections(state, deviationId)) === null || _a === void 0 ? void 0 : _a.collections) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
}
export function getIsNewCollectionSaving(state) {
    return getStoreSlice(state).isNewCollectionSaving;
}
export function getUpdatedEntities(state, deviationId) {
    var _a, _b;
    var entities = {
        collections: {},
    };
    var deviationState = getDeviationState(state, deviationId);
    var currentFolders = (_a = deviationState === null || deviationState === void 0 ? void 0 : deviationState.savedCollections) !== null && _a !== void 0 ? _a : [];
    var selectedFolders = (_b = deviationState === null || deviationState === void 0 ? void 0 : deviationState.selectedCollections) !== null && _b !== void 0 ? _b : [];
    var addedFolders = selectedFolders.filter(function (id) { return !currentFolders.includes(id); });
    var removedFolders = currentFolders.filter(function (id) { return !selectedFolders.includes(id); });
    var collections = getUserCollectionEntities(state);
    var updateFolderSize = function (sizeChange, folderId) {
        if (!collections[folderId]) {
            return;
        }
        entities.collections[folderId] = __assign(__assign({}, collections[folderId]), { size: collections[folderId].size + sizeChange });
    };
    addedFolders.forEach(updateFolderSize.bind(1));
    removedFolders.forEach(updateFolderSize.bind(-1));
    return entities;
}
export function getNewFolderNameBlacklist(state) {
    var collections = getCollectionsRaw(state);
    return collections.map(function (collection) { return collection.name; });
}
export function getIsDeviationInitialized(state, deviationId) {
    var slice = getStoreSlice(state);
    return (slice.deviations.hasOwnProperty(deviationId) &&
        slice.deviations[deviationId].isInitializedForCollecting);
}
export function getSelectedFolderIds(state, deviationId) {
    var _a;
    var slice = getDeviationState(state, deviationId);
    return (_a = slice === null || slice === void 0 ? void 0 : slice.selectedCollections) !== null && _a !== void 0 ? _a : [];
}
export function getFeaturedId(state) {
    var collections = getCollectionsRaw(state);
    var featured = collections.find(function (f) { return f.name === 'Featured'; });
    return featured && featured.folderId;
}
export function getChangeDetails(state, deviationId) {
    var _a;
    var _b = (_a = getDeviationState(state, deviationId)) !== null && _a !== void 0 ? _a : {}, _c = _b.selectedCollections, selected = _c === void 0 ? [] : _c, _d = _b.savedCollections, saved = _d === void 0 ? [] : _d, _e = _b.isFavourite, wasFavourite = _e === void 0 ? false : _e;
    var added = selected.filter(function (f) { return !saved.includes(f); });
    var removed = saved.filter(function (f) { return !selected.includes(f); });
    var kept = saved.filter(function (f) { return selected.includes(f); });
    var willBeFavourite = selected.length > 0;
    return {
        added: added,
        removed: removed,
        selected: selected,
        saved: saved,
        changeType: getChangeType(added.length, removed.length, kept.length),
        wasFavourite: wasFavourite,
        willBeFavourite: willBeFavourite,
    };
}
// TODO: just kill this, it's terrible for perf
// @deprecated
export function getDeviationPatchedWithStoreState(state, deviation) {
    var slice = getStoreSlice(state).deviations[deviation.deviationId];
    if (!slice) {
        return deviation;
    }
    return __assign(__assign({}, deviation), { isFavourited: slice.isFavourite, stats: deviation.stats && __assign(__assign({}, deviation.stats), { favourites: slice.faveCount }) });
}
export function getIsFavourite(state, deviation) {
    var _a, _b;
    var slice = getDeviationState(state, deviation.deviationId);
    return (_b = (_a = slice === null || slice === void 0 ? void 0 : slice.isFavourite) !== null && _a !== void 0 ? _a : deviation.isFavourited) !== null && _b !== void 0 ? _b : false;
}
export function getFaveCount(state, deviation) {
    var _a, _b, _c;
    var slice = getDeviationState(state, deviation.deviationId);
    return (_c = (_a = slice === null || slice === void 0 ? void 0 : slice.faveCount) !== null && _a !== void 0 ? _a : (_b = deviation.stats) === null || _b === void 0 ? void 0 : _b.favourites) !== null && _c !== void 0 ? _c : 0;
}
export function getIsFaveLoading(state, deviation) {
    var _a;
    var slice = getDeviationState(state, deviation.deviationId);
    return (_a = slice === null || slice === void 0 ? void 0 : slice.isLoading) !== null && _a !== void 0 ? _a : false;
}
//# sourceMappingURL=selectors.js.map